import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { Form, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertaModal } from '../componentes-funcionais/alerta-modal/alerta-modal.component';
import { ErroService } from 'src/app/service/erros/erro.service';
import { ProgramacaoFeriasService } from './programacao-ferias.service';
import { IdClassificacaoAto } from '../comissao/comissao.component';
import Swal from 'sweetalert';
import { NgxSpinnerService } from 'ngx-spinner';
import { AnexoComponent } from '../anexo/anexo.component';
import { TipoAviso } from '../ficha-funcional/avisos/avisos.component';
import { MatTabGroup } from '@angular/material/tabs';
import { ObservacoesFichaFuncionalComponent } from '../componentes-funcionais/observacoes-ficha-funcional/observacoes-ficha-funcional.component';
import { Cadastro } from 'src/app/service/classes/cadastro/cadastro';
import { Router } from '@angular/router';
import { LocalStorage } from 'src/app/service/classes/localstorage/LocalStorage';
import { Crypto } from 'src/app/service/classes/crypto/crypto';
import { TipoUsuario } from 'src/app/service/enum/tipoUsuario';

@Component({
  selector: 'app-programacao-ferias',
  templateUrl: './programacao-ferias.component.html',
  styleUrls: ['./programacao-ferias.component.css'],
})
export class ProgramacaoFeriasComponent implements AfterViewInit {
  @ViewChild('inputMatricula') inputMatricula: ElementRef<HTMLInputElement>;
  @ViewChild('tabGroup') tabGroup: MatTabGroup;
  @ViewChild(AnexoComponent) modalAnexo: AnexoComponent;
  @ViewChild(ObservacoesFichaFuncionalComponent)
  modalObservacoes: ObservacoesFichaFuncionalComponent;
  formProgramacaoFerias: FormGroup;
  colaborador: Cadastro = null;
  tipoPagina: string = '104';

  diasGozoValido: boolean = true;
  dataInicioGozoValido: boolean = true;

  diasGozoSaldo: any;
  idClassificacaoAtoSaldo: any;
  numeroAtoSaldo: any;
  anoAtoSaldo: any;
  dtAtoSaldo: any;
  numeroDoeSaldo: any;
  anoDoeSaldo: any;
  dtDoeSaldo: any;
  programacaoSelecionada: any = null;
  dataInicioGozo: string = '';
  historicoGozos: any[] = [];
  listaClassificacao: IdClassificacaoAto[] = [];
  listaTipoFerias: any[] = [];
  tiposFeriasCache: any[] = [];
  listaTipoProcessamento: any[] = [];
  listaSituacao: any[] = [];
  localStorage: LocalStorage;

  matricula = null;
  carregarColaborador: boolean = false;
  temErro: boolean = false;
  validaTelaInicial: boolean = false;
  programacoesFerias: Programacao[] = [];
  modoEdicao: boolean = false;
  programacaoEditando: any = null;
  exibirDataAfastamento: boolean = false;
  exibirCampos: boolean = true;
  situacao: any;
  tipoUsuario: string;
  competenciaAberta: string;
  tipoUsuarioEnum = TipoUsuario;
  usuario: object;

  constructor(
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private programacaoFeriasService: ProgramacaoFeriasService,
    private validaErro: ErroService,
    private router: Router
  ) {
    const navigation = this.router.getCurrentNavigation();
    this.localStorage = this.decryptLocalStorage();
    this.tipoUsuario = this.localStorage.TipoUsuario;

    if (navigation?.extras?.state) {
      this.usuario = navigation.extras.state.usuario;
      this.matricula = navigation.extras.state.usuario.matricula;
    }
  }

  ngOnInit() {
    this.formProgramacaoFerias = this.fb.group({
      matricula: [''],
      nomeFuncionario: [{ value: '', disabled: true }],
      vinculo: [''],
      periodoFerias: [''],
      diasDesc: [{ value: '', disabled: true }],
      diasFaltas: [{ value: '', disabled: true }],
      idClassificacaoAto: ['', Validators.required],
      numeroAto: ['', Validators.required],
      anoAto: [{ value: '', disabled: true }],
      dtAto: ['', Validators.required],
      dtDoe: ['', Validators.required],
      anoDoe: [{ value: '', disabled: true }],
      numeroDoe: ['', Validators.required],
      dataInicioPeriodo: [{ value: '', disabled: true }],
      dataFimPeriodo: [{ value: '', disabled: true }],
      tipoFerias: ['', Validators.required],
      tipoProcessamento: [{ value: '', disabled: true }],
      codigoAfastamento: [{ value: '', disabled: true }],
      descricaoAfastamento: [{ value: '', disabled: true }],
      dataAfastamento: [{ value: '', disabled: true }],
      F11: [''],
      limiteDias1: [{ value: '', disabled: true }],
      dataCompetenciaAberta: [''],

      // Controles para Parte I
      situacao1: ['', Validators.required],
      diasGozo1: ['', Validators.required],
      competencia1: ['', Validators.required],
      dtInicial1: ['', Validators.required],
      dtFinal1: [{ value: '', disabled: true }],
      dtRetorno1: [{ value: '', disabled: true }],
      diasSeremPagos1: ['', Validators.required],

      // Controles para Parte II
      situacao2: [''],
      diasGozo2: [''],
      competencia2: [''],
      dtInicial2: [''],
      dtFinal2: [{ value: '', disabled: true }],
      dtRetorno2: [{ value: '', disabled: true }],
      diasSeremPagos2: [''],

      // Controles para Parte III
      situacao3: [''],
      diasGozo3: [''],
      competencia3: [''],
      dtInicial3: [''],
      dtFinal3: [{ value: '', disabled: true }],
      dtRetorno3: [{ value: '', disabled: true }],
      diasSeremPagos3: [''],

      // Controles do Saldo
    });

    if (this.usuario) {
      this.carregarDadosUsuario(this.usuario['nome'], this.usuario['matricula']);
    } else if (this.tipoUsuario === TipoUsuario.portal) {
    }

    this.buscarClassificacao();
    this.buscarParametrosIniciais();
    this.buscarTipoFerias();
    this.buscarSituacao();

    this.formProgramacaoFerias
      .get('diasSeremPagos1')
      ?.valueChanges.subscribe(() => this.validarDiasPagos());
    this.formProgramacaoFerias
      .get('diasSeremPagos2')
      ?.valueChanges.subscribe(() => this.validarDiasPagos());
    this.formProgramacaoFerias
      .get('diasSeremPagos3')
      ?.valueChanges.subscribe(() => this.validarDiasPagos());
    this.formProgramacaoFerias
      .get('diasGozo1')
      ?.valueChanges.subscribe(() => this.validarLimites());
    this.formProgramacaoFerias
      .get('diasGozo2')
      ?.valueChanges.subscribe(() => this.validarLimites());
    this.formProgramacaoFerias
      .get('diasGozo3')
      ?.valueChanges.subscribe(() => this.validarLimites());

    this.formProgramacaoFerias.get('tipoFerias')?.valueChanges.subscribe(() => {
      this.buscarDadosDiasDescontados();
    });

    this.formProgramacaoFerias.get('tipoFerias')?.valueChanges.subscribe(() => {
      this.validarDiasPagos();
    });

    this.formProgramacaoFerias.get('tipoFerias').valueChanges.subscribe((codigoSelecionado) => {
      if (!codigoSelecionado) return;

      const tipoSelecionado = this.listaTipoFerias.find((item) => item.Codigo == codigoSelecionado);
      if (tipoSelecionado?.Saldo === 'S') {
        this.desabilitarParte(2, true);
        this.desabilitarParte(3, true);
      } else {
        this.desabilitarParte(2, false);
        this.desabilitarParte(3, false);
      }
    });

    this.programacaoFeriasService.buscarTipoFerias().subscribe({
      next: (opcoesFerias: any[]) => {
        this.tiposFeriasCache = opcoesFerias;
      },
      error: (error) => {
        this.validaErro.retornoErro(error);
      },
    });
  }

  ngAfterViewInit() {
    if (this.inputMatricula) {
      this.inputMatricula.nativeElement.focus();
      console.log(this.inputMatricula.nativeElement);
    }
  }

  carregarDadosUsuario(nome: string, matricula: string) {
    this.formProgramacaoFerias.get('matricula')?.setValue(matricula);
    this.buscarColaborador(matricula);
  }

  decryptLocalStorage(): LocalStorage {
    if (localStorage.getItem('util') != null) {
      return JSON.parse(new Crypto().decryptUsingAES256(localStorage.getItem('util')));
    }
  }

  validarFormulario(): boolean {
    if (this.formProgramacaoFerias.invalid) {
      if (this.temErroNaAba(1)) {
        this.tabGroup.selectedIndex = 0;
      } else if (this.temErroNaAba(2)) {
        this.tabGroup.selectedIndex = 1;
      } else if (this.temErroNaAba(3)) {
        this.tabGroup.selectedIndex = 2;
      }
      Swal('Atenção', 'Preencha todos os campos corretamente.', 'warning');
      return false;
    }
    return true;
  }

  private temErroNaAba(parte: number): boolean {
    return (
      this.formProgramacaoFerias.get(`situacao${parte}`).invalid ||
      this.formProgramacaoFerias.get(`dtInicial${parte}`).invalid ||
      this.formProgramacaoFerias.get(`competencia${parte}`).invalid ||
      this.formProgramacaoFerias.get(`diasSeremPagos${parte}`).invalid ||
      this.formProgramacaoFerias.get(`diasGozo${parte}`).invalid
    );
  }

  alterarMatricula(): void {
    const matricula = this.formProgramacaoFerias.get('matricula').value;
    if (matricula === '') {
      this.formProgramacaoFerias.get('nomeFuncionario').setValue('');
    }
  }

  matriculaListener(evento) {
    this.matricula = evento.Matricula;
    this.formProgramacaoFerias.get('matricula').setValue(this.matricula);
    this.formProgramacaoFerias.get('matricula').disable();
    this.buscarColaborador(this.matricula);
    this.modalAnexo.inicializarComponente(evento);
  }

  buscarColaborador(matricula): void {
    if (matricula === '') {
      new AlertaModal('erro', 'Atenção', 'O campo matrícula precisa ser preenchido.', 'p');
      return;
    }

    this.formProgramacaoFerias.markAsUntouched();
    this.formProgramacaoFerias.markAsPristine();
    this.formProgramacaoFerias.patchValue({
      nomeFuncionario: '',
      vinculo: '',
      tipoFerias: '',
      numeroDoe: '',
      anoDoe: '',
      dtDoe: null,
      idClassificacaoAto: '',
      numeroAto: '',
      anoAto: '',
      dtAto: null,
      situacao1: '',
      competencia1: '',
      diasGozo1: null,
      dtInicial1: null,
      dtFinal1: null,
      dtRetorno1: null,
      situacao2: '',
      competencia2: '',
      diasGozo2: null,
      dtInicial2: null,
      dtFinal2: null,
      dtRetorno2: null,
      situacao3: '',
      competencia3: '',
      diasGozo3: null,
      dtInicial3: null,
      dtFinal3: null,
      dtRetorno3: null,
      codigoAfastamento: '',
      dataAfastamento: null,
      F11: '',
      dataCompetenciaAberta: '',
    });

    this.matricula = matricula;

    this.programacaoFeriasService.buscarParametrosIniciais().subscribe({
      next: (parametros: any) => {
        this.formProgramacaoFerias.get('tipoProcessamento')?.setValue(parametros.TipoProcessamento);

        const tpProc = this.formProgramacaoFerias.get('tipoProcessamento')?.value;

        this.buscarCompetenciaAberta(tpProc).then(() => {
          this.buscarDadosDiasDescontados();
          this.listarProgramacaoFerias();
          this.buscarPeriodoAquisitivo();
          this.buscarDadosFaltas();

          this.programacaoFeriasService.buscarColaborador(matricula).subscribe(
            (data: any) => {
              if (data.Nome !== '') {
                let dataAfastamentoFormatada = null;
                if (data.DataAfastamento) {
                  if (
                    data.DataAfastamento.SetData &&
                    typeof data.DataAfastamento.SetData === 'string'
                  ) {
                    const dataStr = data.DataAfastamento.SetData;
                    if (dataStr !== '00000000' && dataStr.length === 8) {
                      dataAfastamentoFormatada = `${dataStr.substring(0, 4)}-${dataStr.substring(
                        4,
                        6
                      )}-${dataStr.substring(6, 8)}`;
                    }
                  } else if (
                    typeof data.DataAfastamento === 'string' &&
                    data.DataAfastamento.length >= 10
                  ) {
                    dataAfastamentoFormatada = data.DataAfastamento.substring(0, 10);
                  }
                }

                this.formProgramacaoFerias.patchValue({
                  nomeFuncionario: data.Nome,
                  vinculo: data.Vinculo,
                  codigoAfastamento: data.CodigoAfastamento || '',
                  descricaoAfastamento: data.DescricaoAfastamento || '',
                  F11: data.F11,
                  dataAfastamento: dataAfastamentoFormatada,
                });

                const f11 = data.F11;
                const dataAfastamento = dataAfastamentoFormatada;
                const competenciaAberta =
                  this.formProgramacaoFerias.get('dataCompetenciaAberta')?.value;

                if (f11 === 0 && dataAfastamento !== competenciaAberta) {
                  this.exibirCampos = false;
                } else {
                  this.exibirCampos = true;
                }

                this.exibirDataAfastamento = !!dataAfastamentoFormatada;
                this.colaborador = data;
                console.log('Colaborador carregado:', this.colaborador);
              } else {
                new AlertaModal(
                  'erro',
                  'Atenção',
                  'A matrícula digitada não existe para esta empresa filial.',
                  'p'
                );
              }
            },
            (error) => {
              this.validaErro.retornoErro(error);
            }
          );
        });
      },
    });
  }

  buscarClassificacao() {
    this.spinner.show();
    this.programacaoFeriasService.buscarClassificacao().subscribe({
      next: (data: any) => {
        this.spinner.hide();
        this.listaClassificacao = data;
      },
      error: (error) => {
        this.spinner.hide();
        this.validaErro.retornoErro(error);
      },
    });
  }

  aoAlterarData(evento, campo: string) {
    if (evento.target.value.length === 10) {
      const dataSplit = evento.target.value.split('-');
      this.formProgramacaoFerias.get(campo).setValue(dataSplit[0]);
    } else {
      this.formProgramacaoFerias.get(campo).setValue('');
    }
  }

  aoAlterarDataSaldo(event: Event, campoAno: string) {
    const input = event.target as HTMLInputElement;
    if (input.value.length === 10) {
      const dataSplit = input.value.split('-');
      if (campoAno === 'anoDoeSaldo') {
        this.anoDoeSaldo = dataSplit[0];
      } else if (campoAno === 'anoAtoSaldo') {
        this.anoAtoSaldo = dataSplit[0];
      }
    } else {
      if (campoAno === 'anoDoeSaldo') {
        this.anoDoeSaldo = '';
      } else if (campoAno === 'anoAtoSaldo') {
        this.anoAtoSaldo = '';
      }
    }
  }

  buscarParametrosIniciais() {
    this.spinner.show();
    this.programacaoFeriasService.buscarParametrosIniciais().subscribe({
      next: (data: any) => {
        this.spinner.hide();
        this.listaTipoProcessamento = data;

        this.formProgramacaoFerias.get('tipoProcessamento')?.setValue(data.TipoProcessamento);
        this.formProgramacaoFerias.get('tipoProcessamento')?.updateValueAndValidity();
      },
      error: (error) => {
        this.spinner.hide();
        this.validaErro.retornoErro(error);
      },
    });
  }

  buscarCompetenciaAberta(tpProc: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this.spinner.show();

      const empFil = this.programacaoFeriasService.filial;

      this.programacaoFeriasService.buscarCompetenciaAberta(tpProc, empFil).subscribe({
        next: (data: any) => {
          this.spinner.hide();
          this.formProgramacaoFerias.get('dataCompetenciaAberta')?.setValue(data.competencia);
          resolve();
        },
        error: (error) => {
          this.spinner.hide();
          this.validaErro.retornoErro(error);
        },
      });
    });
  }

  buscarTipoFerias() {
    this.spinner.show();

    this.programacaoFeriasService.buscarTipoFerias().subscribe({
      next: (data: any) => {
        this.spinner.hide();
        this.listaTipoFerias = data;
      },
      error: (error) => {
        this.spinner.hide();
        this.validaErro.retornoErro(error);
      },
    });
  }

  buscarSituacao() {
    this.spinner.show();
    this.programacaoFeriasService.buscarSituacao().subscribe({
      next: (data: any) => {
        this.spinner.hide();
        this.listaSituacao = data;
      },
      error: (error) => {
        this.spinner.hide();
        this.validaErro.retornoErro(error);
      },
    });
  }
  buscarDiasFaltas() {
    this.spinner.show();
    this.programacaoFeriasService.buscarDiasFaltas(this.matricula).subscribe({
      next: (data: any) => {
        this.spinner.hide();
      },
      error: (error) => {
        this.spinner.hide();
        this.validaErro.retornoErro(error);
      },
    });
  }

  buscarDadosFaltas() {
    this.spinner.show();

    const empFil = this.programacaoFeriasService.filial;
    const matricula = this.matricula;

    this.programacaoFeriasService.buscarParametrosIniciais().subscribe({
      next: (parametros: any) => {
        const tipoEmpresa = parametros.TipoEmpresa;

        this.programacaoFeriasService.buscarDadosFaltas(matricula, empFil, tipoEmpresa).subscribe({
          next: (data: any) => {
            this.spinner.hide();
            this.formProgramacaoFerias.get('diasFaltas')?.setValue(data.DiasFaltas || 0);
            this.formProgramacaoFerias.get('diasDesc')?.setValue(data.DiasDescontados || 0);
          },
          error: (error) => {
            this.spinner.hide();
            this.validaErro.retornoErro(error);
          },
        });
      },
    });
  }

  buscarDadosDiasDescontados() {
    this.spinner.show();

    this.programacaoFeriasService.buscarParametrosIniciais().subscribe({
      next: (parametros: any) => {
        const tipoEmpresa = parametros.TipoEmpresa;

        this.programacaoFeriasService.buscarDiasFaltas(this.matricula).subscribe({
          next: (diasData: any) => {
            const diasFaltas = diasData.Dias || 0;

            this.programacaoFeriasService.buscarTipoFerias().subscribe({
              next: (opcoesFerias: any[]) => {
                this.spinner.hide();

                if (tipoEmpresa != null) {
                  this.programacaoFeriasService
                    .buscarDiasDescontados(tipoEmpresa, diasFaltas.toString())
                    .subscribe({
                      next: (descontados: any) => {
                        const diasDescontados = Number(descontados.diasDescontados) || 0;
                        const tipoFerias = Number(
                          this.formProgramacaoFerias.get('tipoFerias')?.value
                        );

                        const opcaoSelecionada = opcoesFerias.find(
                          (opcao) => opcao.Codigo === tipoFerias
                        );

                        let limiteDias = opcaoSelecionada
                          ? opcaoSelecionada.DiasFerias - diasDescontados
                          : 0 + diasDescontados;

                        limiteDias = Math.max(limiteDias, 0);

                        this.formProgramacaoFerias
                          .get('diasDescontados')
                          ?.setValue(diasDescontados);
                        this.formProgramacaoFerias.get('limiteDias1')?.setValue(limiteDias);
                        this.formProgramacaoFerias.get('limiteDias2')?.setValue(limiteDias);
                        this.formProgramacaoFerias.get('limiteDias3')?.setValue(limiteDias);

                        this.formProgramacaoFerias.get('dtFinal1')?.disable();
                        this.formProgramacaoFerias.get('dtRetorno1')?.disable();
                        this.formProgramacaoFerias.get('dtFinal2')?.disable();
                        this.formProgramacaoFerias.get('dtRetorno2')?.disable();
                        this.formProgramacaoFerias.get('dtFinal3')?.disable();
                        this.formProgramacaoFerias.get('dtRetorno3')?.disable();
                      },
                      error: (err) => {
                        console.error('Erro ao buscar dias descontados:', err);
                        Swal('Erro', 'Não foi possível buscar os dias descontados.', 'error');
                      },
                    });
                } else {
                  console.warn('Dados insuficientes para buscar os dias descontados.');
                }
              },
              error: (erro) => {
                this.spinner.hide();
                console.error('Erro ao buscar opções de férias:', erro);
                Swal('Erro', 'Não foi possível buscar os dados das férias.', 'error');
              },
            });
          },
          error: (erro) => {
            this.spinner.hide();
            console.error('Erro ao buscar dias de faltas:', erro);
            Swal('Erro', 'Não foi possível buscar os dias de faltas.', 'error');
          },
        });
      },
      error: (error) => {
        this.spinner.hide();
        Swal({
          title: 'Erro!',
          text: error.error?.Mensagem || 'Não foi possível buscar os parâmetros iniciais.',
          icon: 'error',
        });
      },
    });
  }

  salvarProgramacaoFerias(): void {
    this.formProgramacaoFerias.markAllAsTouched();

    if (!this.validarFormulario()) {
      return;
    }

    const diasDescontados = this.formProgramacaoFerias.get('diasDescontados')?.value || 0;
    const diasPagos1 = this.formProgramacaoFerias.get('diasSeremPagos1')?.value || 0;
    const diasPagos2 = this.formProgramacaoFerias.get('diasSeremPagos2')?.value || 0;
    const diasPagos3 = this.formProgramacaoFerias.get('diasSeremPagos3')?.value || 0;
    const tipoFerias = Number(this.formProgramacaoFerias.get('tipoFerias')?.value);

    this.programacaoFeriasService.buscarTipoFerias().subscribe({
      next: (opcoesFerias: any[]) => {
        const opcaoSelecionada = opcoesFerias.find((opcao) => opcao.Codigo === tipoFerias);
        let limiteTotalDias = opcaoSelecionada ? opcaoSelecionada.DiasFerias - diasDescontados : 0;

        const totalDiasPagos = diasPagos1 + diasPagos2 + diasPagos3;
        const diasRestantes = limiteTotalDias - totalDiasPagos;

        if (diasRestantes > 0) {
          Swal('Aviso', `Ainda restam ${diasRestantes} dias para serem alocados!`, 'warning');
          return;
        }

        this.spinner.show();

        const cadastro = this.montarCadastro();

        this.programacaoFeriasService.salvarProgramacaoFerias(cadastro).subscribe({
          next: () => {
            this.spinner.hide();

            Swal({
              title: 'Sucesso!',
              text: 'Programação de férias cadastrada com sucesso.',
              icon: 'success',
            }).then(() => {
              this.limparFormulario();
              this.listarProgramacaoFerias();
              this.buscarPeriodoAquisitivo();
            });
          },
          error: (error) => {
            this.spinner.hide();

            Swal({
              title: 'Erro!',
              text:
                error.error?.Mensagem || 'Ocorreu um erro ao cadastrar a programação de férias.',
              icon: 'error',
            });
          },
        });
      },
      error: (erro) => {
        console.error('Erro ao buscar opções de férias:', erro);
        Swal('Erro', 'Não foi possível obter os dados de férias.', 'error');
      },
    });
  }

  limparFormulario(): void {
    const dadosFixos = {
      matricula: this.formProgramacaoFerias.get('matricula')?.value,
      nomeFuncionario: this.formProgramacaoFerias.get('nomeFuncionario')?.value,
      tipoProcessamento: this.formProgramacaoFerias.get('tipoProcessamento')?.value,
      codigoAfastamento: this.formProgramacaoFerias.get('codigoAfastamento')?.value,
      descricaoAfastamento: this.formProgramacaoFerias.get('descricaoAfastamento')?.value,
      idClassificacaoAto: '',
      tipoFerias: '',
      situacao1: '',
      situacao2: '',
      situacao3: '',
    };
    this.formProgramacaoFerias.reset(dadosFixos);
    this.formProgramacaoFerias.markAsUntouched();
    this.formProgramacaoFerias.markAsPristine();
  }

  inverterCompetencia(competencia: string): string {
    if (competencia.length === 6) {
      const mes = competencia.substring(0, 2);
      const ano = competencia.substring(2, 6);
      return `${ano}${mes}`;
    }
    return competencia;
  }

  montarCadastro(): any {
    const formValues = this.formProgramacaoFerias.getRawValue();
    const partesFerias = [
      {
        // Parte I
        Competencia: this.inverterCompetencia(formValues.competencia1),
        Situacao: {
          Codigo: Number(formValues.situacao1) || 0,
        },
        DiasGozo: Number(formValues.diasGozo1),
        DataInicio: formValues.dtInicial1
          ? {
              SetData: formValues.dtInicial1.replace(/-/g, ''),
              ToDate: this.formatarDataBarra(formValues.dtInicial1.replace(/-/g, '')),
              Empty: false,
              IsDate: true,
            }
          : '00000000',
        DataFim: formValues.dtFinal1
          ? {
              SetData: formValues.dtFinal1.replace(/-/g, ''),
              ToDate: this.formatarDataBarra(formValues.dtFinal1.replace(/-/g, '')),
              Empty: false,
              IsDate: true,
            }
          : '00000000',
        DataRetorno: formValues.dtRetorno1
          ? {
              SetData: formValues.dtRetorno1.replace(/-/g, ''),
              ToDate: this.formatarDataBarra(formValues.dtRetorno1.replace(/-/g, '')),
              Empty: false,
              IsDate: true,
            }
          : '00000000',
        Condespensa: 0,
      },
      {
        // Parte II
        Competencia: formValues.competencia2
          ? this.inverterCompetencia(formValues.competencia2)
          : undefined,
        Situacao: formValues.situacao2 ? { Codigo: Number(formValues.situacao2) } : undefined,

        DiasGozo: formValues.diasGozo2 ? Number(formValues.diasGozo2) : undefined,
        DataInicio: formValues.dtInicial2
          ? {
              SetData: formValues.dtInicial2.replace(/-/g, ''),
              ToDate: this.formatarDataBarra(formValues.dtInicial2.replace(/-/g, '')),
              Empty: false,
              IsDate: true,
            }
          : undefined,
        DataFim: formValues.dtFinal2
          ? {
              SetData: formValues.dtFinal2.replace(/-/g, ''),
              ToDate: this.formatarDataBarra(formValues.dtFinal2.replace(/-/g, '')),
              Empty: false,
              IsDate: true,
            }
          : undefined,
        DataRetorno: formValues.dtRetorno2
          ? {
              SetData: formValues.dtRetorno2.replace(/-/g, ''),
              ToDate: this.formatarDataBarra(formValues.dtRetorno2.replace(/-/g, '')),
              Empty: false,
              IsDate: true,
            }
          : undefined,
        Condespensa: 0,
      },

      {
        // Parte III
        Competencia: formValues.competencia3
          ? this.inverterCompetencia(formValues.competencia3)
          : undefined,
        Situacao: formValues.situacao3 ? { Codigo: Number(formValues.situacao3) } : undefined,

        DiasGozo: formValues.diasGozo3 ? Number(formValues.diasGozo3) : undefined,
        DataInicio: formValues.dtInicial3
          ? {
              SetData: formValues.dtInicial3.replace(/-/g, ''),
              ToDate: this.formatarDataBarra(formValues.dtInicial3.replace(/-/g, '')),
              Empty: false,
              IsDate: true,
            }
          : undefined,
        DataFim: formValues.dtFinal3
          ? {
              SetData: formValues.dtFinal3.replace(/-/g, ''),
              ToDate: this.formatarDataBarra(formValues.dtFinal3.replace(/-/g, '')),
              Empty: false,
              IsDate: true,
            }
          : undefined,
        DataRetorno: formValues.dtRetorno3
          ? {
              SetData: formValues.dtRetorno3.replace(/-/g, ''),
              ToDate: this.formatarDataBarra(formValues.dtRetorno3.replace(/-/g, '')),
              Empty: false,
              IsDate: true,
            }
          : undefined,
        Condespensa: 0,
      },
    ];

    const partesFeriasFiltradas = partesFerias.filter((parte) => {
      return (
        parte.Competencia !== undefined ||
        parte.Situacao !== undefined ||
        parte.DiasGozo !== undefined ||
        parte.DataInicio !== undefined ||
        parte.DataFim !== undefined ||
        parte.DataRetorno !== undefined
      );
    });

    return {
      Sigla: 'FAPP',
      EmpresaFilial: this.programacaoFeriasService.filial,
      Matricula: Number(formValues.matricula) || 0,
      TipoProcessamento: formValues.tipoProcessamento || '',
      PeriodoAquisitivo: {
        DataInicio: {
          SetData: formValues.dataInicioPeriodo
            ? formValues.dataInicioPeriodo.replace(/-/g, '')
            : '',
          ToDate: formValues.dataInicioPeriodo
            ? this.formatarDataBarra(formValues.dataInicioPeriodo.replace(/-/g, ''))
            : '',
          IsDate: true,
          Empty: false,
        },
        DataFim: {
          SetData: formValues.dataFimPeriodo ? formValues.dataFimPeriodo.replace(/-/g, '') : '',
          ToDate: formValues.dataFimPeriodo
            ? this.formatarDataBarra(formValues.dataFimPeriodo.replace(/-/g, ''))
            : '',
          IsDate: true,
          Empty: false,
        },
      },
      DiasSeremPagos:
        Number(formValues.diasSeremPagos1) +
        Number(formValues.diasSeremPagos2) +
        Number(formValues.diasSeremPagos3),
      DiasGozoRessalva: 0,
      TipoFerias: formValues.tipoFerias || '',
      NumeroProcesso: '',
      NumeroDOE: formValues.numeroDoe || '',
      IdClassificacaoAto: formValues.idClassificacaoAto || '0',
      NumeroAto: formValues.numeroAto || '',
      AnoAto: formValues.anoAto || '',
      DataAto: formValues.dtAto
        ? {
            SetData: formValues.dtAto.replace(/-/g, ''),
            ToDate: this.formatarDataBarra(formValues.dtAto.replace(/-/g, '')),
            Empty: false,
            IsDate: true,
          }
        : '00000000',
      AnoDOE: formValues.anoDoe || '',
      DataDOE: formValues.dtDoe
        ? {
            SetData: formValues.dtDoe.replace(/-/g, ''),
            ToDate: this.formatarDataBarra(formValues.dtDoe.replace(/-/g, '')),
            Empty: false,
            IsDate: true,
          }
        : '00000000',
      CompAtualizacao: '000000',
      DiasSaldo: 0,
      PartesFerias: partesFeriasFiltradas,
    };
  }

  formatarDataBarra(data: string): string {
    if (!data || data.length !== 8) return data;
    const ano = data.substring(0, 4);
    const mes = data.substring(4, 6);
    const dia = data.substring(6, 8);

    return `${dia}/${mes}/${ano}`;
  }

  listarProgramacaoFerias() {
    if (!this.matricula) {
      Swal({
        title: 'Erro!',
        text: 'Matrícula não foi definida antes da listagem.',
        icon: 'error',
      });
      return;
    }

    this.spinner.show();

    this.programacaoFeriasService
      .listarProgramacaoFerias(
        this.programacaoFeriasService.filial,
        this.matricula || undefined,
        this.situacao || undefined
      )
      .subscribe({
        next: (data: any) => {
          this.spinner.hide();

          this.programacoesFerias = this.agruparPorPeriodoAquisitivo(data);
        },
        error: (error) => {
          this.spinner.hide();
          Swal({
            title: 'Erro!',
            text: error.error?.Mensagem || 'Não foi possível listar as programações de férias.',
            icon: 'error',
          });
        },
      });
  }

  agruparPorPeriodoAquisitivo(programacoes: Programacao[]): Programacao[] {
    const agrupadas: { [key: string]: Programacao } = {};
    const contadorAgrupamentos: { [key: string]: number } = {};

    programacoes.forEach((programacao) => {
      const chave = this.gerarChavePeriodoAquisitivo(programacao.PeriodoAquisitivo);

      if (!contadorAgrupamentos[chave]) {
        contadorAgrupamentos[chave] = 0;
      }
      contadorAgrupamentos[chave]++;

      if (!agrupadas[chave]) {
        agrupadas[chave] = { ...programacao };
        agrupadas[chave].QuantidadeAgrupada = 1;

        if (!agrupadas[chave].PartesFerias) {
          agrupadas[chave].PartesFerias = [];
        }

        if (programacao.PartesFerias && programacao.PartesFerias.length > 0) {
          agrupadas[chave].PartesFerias = [...programacao.PartesFerias];
        }
      } else {
        if (programacao.PartesFerias && programacao.PartesFerias.length > 0) {
          agrupadas[chave].PartesFerias = [
            ...agrupadas[chave].PartesFerias,
            ...programacao.PartesFerias,
          ];
        }

        agrupadas[chave].DiasGozo += programacao.DiasGozo || 0;

        agrupadas[chave].QuantidadeAgrupada = contadorAgrupamentos[chave];
      }
    });

    return Object.values(agrupadas);
  }

  gerarChavePeriodoAquisitivo(periodo: {
    DataInicio: { SetData?: string; ToDate?: string };
    DataFim: { SetData?: string; ToDate?: string };
  }): string {
    const inicio = periodo.DataInicio?.SetData || periodo.DataInicio?.ToDate || '';
    const fim = periodo.DataFim?.SetData || periodo.DataFim?.ToDate || '';
    return `${inicio}-${fim}`;
  }

  formatarData(data: string): string {
    if (!data || data.length !== 8) {
      return data;
    }
    const ano = data.slice(0, 4);
    const mes = data.slice(4, 6);
    const dia = data.slice(6, 8);

    return `${dia}/${mes}/${ano}`;
  }

  atualizarProgramacaoFerias(programacao: any) {
    this.modoEdicao = true;
    this.programacaoEditando = programacao;

    let partes = programacao.PartesFerias || [];

    let totalDiasSeremPagos = programacao.DiasSeremPagos ?? 0;

    let diasSeremPagosParte1 = partes[0]?.DiasGozo ?? 0;
    let diasSeremPagosParte2 = partes[1]?.DiasGozo ?? 0;
    let diasSeremPagosParte3 = partes[2]?.DiasGozo ?? 0;

    let somaDiasGozo = diasSeremPagosParte1 + diasSeremPagosParte2 + diasSeremPagosParte3;
    if (somaDiasGozo > totalDiasSeremPagos) {
      diasSeremPagosParte3 = Math.max(
        0,
        totalDiasSeremPagos - (diasSeremPagosParte1 + diasSeremPagosParte2)
      );
      diasSeremPagosParte2 = Math.max(
        0,
        totalDiasSeremPagos - diasSeremPagosParte1 - diasSeremPagosParte3
      );
    }

    this.formProgramacaoFerias.patchValue({
      matricula: programacao.Matricula,
      tipoProcessamento: programacao.TipoProcessamento,
      dataInicioPeriodo: this.formatarDataParaEnvio3(
        programacao.PeriodoAquisitivo?.DataInicio?.ToDate
      ),
      dataFimPeriodo: this.formatarDataParaEnvio3(programacao.PeriodoAquisitivo?.DataFim?.ToDate),
      tipoFerias: programacao.TipoFerias,
      numeroDoe: programacao.NumeroDOE,
      anoDoe: programacao.AnoDOE,
      dtDoe: this.formatarDataParaEnvio3(programacao.DataDOE?.ToDate),
      idClassificacaoAto: programacao.IdClassificacaoAto,
      numeroAto: programacao.NumeroAto,
      anoAto: programacao.AnoAto,
      dtAto: this.formatarDataParaEnvio3(programacao.DataAto?.ToDate),

      diasSeremPagos1: diasSeremPagosParte1,
      diasSeremPagos2: diasSeremPagosParte2,
      diasSeremPagos3: diasSeremPagosParte3,

      // Parte I
      situacao1: partes[0]?.Situacao.Codigo || '',
      competencia1: this.formatarCompetencia(partes[0]?.Competencia),
      diasGozo1: diasSeremPagosParte1,
      dtInicial1: this.formatarDataParaEnvio3(partes[0]?.DataInicio?.ToDate),
      dtFinal1: this.formatarDataParaEnvio3(partes[0]?.DataFim?.ToDate),
      dtRetorno1: this.formatarDataParaEnvio3(partes[0]?.DataRetorno?.ToDate),

      // Parte II
      situacao2: partes[1]?.Situacao.Codigo || '',
      competencia2: this.formatarCompetencia(partes[1]?.Competencia),
      diasGozo2: diasSeremPagosParte2,
      dtInicial2: this.formatarDataParaEnvio3(partes[1]?.DataInicio?.ToDate),
      dtFinal2: this.formatarDataParaEnvio3(partes[1]?.DataFim?.ToDate),
      dtRetorno2: this.formatarDataParaEnvio3(partes[1]?.DataRetorno?.ToDate),

      // Parte III
      situacao3: partes[2]?.Situacao.Codigo || '',
      competencia3: this.formatarCompetencia(partes[2]?.Competencia),
      diasGozo3: diasSeremPagosParte3,
      dtInicial3: this.formatarDataParaEnvio3(partes[2]?.DataInicio?.ToDate),
      dtFinal3: this.formatarDataParaEnvio3(partes[2]?.DataFim?.ToDate),
      dtRetorno3: this.formatarDataParaEnvio3(partes[2]?.DataRetorno?.ToDate),
    });
    this.redirecionarParaParte1();
  }

  private redirecionarParaParte1() {
    if (this.tabGroup) {
      setTimeout(() => {
        this.tabGroup.selectedIndex = 0;
      }, 0);
    }
  }

  formatarCompetencia(competencia: string): string {
    if (!competencia || competencia.length !== 6) {
      return competencia;
    }
    const ano = competencia.substring(0, 4);
    const mes = competencia.substring(4, 6);

    return `${mes}/${ano}`;
  }

  selecionarProgramacao(programacao: any) {
    this.spinner.show();

    const tpProc = programacao.TipoProcessamento;

    this.programacaoFeriasService
      .editarProgramacaoFerias(
        this.programacaoFeriasService.filial,
        this.matricula,
        tpProc,
        this.formatarDataParaEnvio2(programacao.PeriodoAquisitivo?.DataInicio?.ToDate),
        this.formatarDataParaEnvio2(programacao.PeriodoAquisitivo?.DataFim?.ToDate)
      )
      .subscribe({
        next: (dados) => {
          this.spinner.hide();
          this.atualizarProgramacaoFerias(dados);

          this.buscarCompetenciaAberta(tpProc);
        },
        error: (error) => {
          this.spinner.hide();

          Swal({
            title: 'Erro!',
            text: error.error?.Mensagem || 'Não foi possível carregar os dados da programação.',
            icon: 'error',
          });
        },
      });
  }

  salvarEdicaoProgramacaoFerias() {
    this.formProgramacaoFerias.markAllAsTouched();
    if (this.formProgramacaoFerias.invalid) {
      Swal('Atenção', 'Preencha todos os campos corretamente.', 'warning');
      return;
    }

    this.spinner.show();

    const cadastroAtualizado = this.montarCadastro();

    const programacao = this.programacaoEditando;

    if (!programacao) {
      this.spinner.hide();
      Swal('Erro', 'Nenhuma programação de férias foi selecionada.', 'error');
      return;
    }

    const tpProc = programacao.TipoProcessamento;
    const dataInicioPeriodo = this.formatarDataParaEnvio2(
      programacao.PeriodoAquisitivo?.DataInicio?.ToDate
    );
    const dataFimPeriodo = this.formatarDataParaEnvio2(
      programacao.PeriodoAquisitivo?.DataFim?.ToDate
    );

    if (!tpProc || !dataInicioPeriodo || !dataFimPeriodo) {
      this.spinner.hide();
      Swal('Erro', 'Dados obrigatórios ausentes. Verifique o formulário.', 'error');
      return;
    }

    this.programacaoFeriasService
      .atualizarProgramacaoFerias(
        this.programacaoFeriasService.filial,
        this.matricula,
        tpProc,
        dataInicioPeriodo,
        dataFimPeriodo,
        cadastroAtualizado
      )
      .subscribe({
        next: () => {
          this.spinner.hide();
          Swal('Sucesso', 'Programação de férias atualizada com sucesso.', 'success');
          this.listarProgramacaoFerias();
          this.cancelarEdicao();
        },
        error: (erro) => {
          this.spinner.hide();
          Swal(
            'Erro',
            erro.error?.Mensagem || 'Ocorreu um erro ao atualizar a programação de férias.',
            'error'
          );
        },
      });
  }

  cancelarEdicao() {
    this.modoEdicao = false;
    this.programacaoEditando = null;
    const dadosFixos = {
      matricula: this.formProgramacaoFerias.get('matricula')?.value,
    };
    this.formProgramacaoFerias.reset(dadosFixos);

    this.buscarClassificacao();
    this.buscarParametrosIniciais();
    this.buscarTipoFerias();
    this.buscarSituacao();

    this.buscarColaborador(this.matricula);
  }

  formatarDataGozo(data: any): string {
    if (!data) return '';
    const d = new Date(data);
    return d.toLocaleDateString('pt-BR');
  }

  calcularDataFinalGozo(): string {
    if (!this.dataInicioGozo || !this.diasGozoSaldo) return '';

    const inicio = this.parseDate(this.dataInicioGozo);
    const dias = parseInt(this.diasGozoSaldo, 10);

    if (isNaN(dias)) return '';

    const dataFim = this.calcularDataFinalCorreta(inicio, dias);
    return dataFim.toISOString().split('T')[0];
  }

  abrirModal(programacao: any): void {
    console.log('Programação completa:', programacao);
    console.log('Número da ordem:', this.colaborador.NumeroOrdem);
    this.programacaoSelecionada = {
      ...programacao,
      NumeroOrdem: this.colaborador.NumeroOrdem,
    };

    this.diasGozoSaldo = programacao?.DiasGozoSaldo;
    this.dataInicioGozo = programacao?.DataInicioGozo;

    this.buscarHistoricoGozos();
  }

  buscarHistoricoGozos() {
    if (!this.programacaoSelecionada) {
      Swal('Atenção', 'Nenhuma programação de férias selecionada.', 'warning');
      return;
    }

    this.spinner.show();

    const priAqFerias = this.formatarDataParaEnvio2(
      this.programacaoSelecionada.PeriodoAquisitivo?.DataInicio?.ToDate
    );
    const segAqFerias = this.formatarDataParaEnvio2(
      this.programacaoSelecionada.PeriodoAquisitivo?.DataFim?.ToDate
    );

    const numeroOrdem = this.colaborador.NumeroOrdem;

    this.programacaoFeriasService
      .buscarHistoricoGozos(priAqFerias, segAqFerias, numeroOrdem)
      .subscribe({
        next: (historico: any[]) => {
          this.spinner.hide();
          this.historicoGozos = historico || [];
        },
        error: (error) => {
          this.spinner.hide();
          console.error('Erro ao buscar histórico de gozos:', error);
          Swal(
            'Erro',
            error.error?.Mensagem || 'Não foi possível buscar o histórico de gozos.',
            'error'
          );
        },
      });
  }

  isGozoPassado(dataInicio: any): boolean {
    if (!dataInicio) return false;

    try {
      let dataStr: string;

      if (dataInicio.ToDate && typeof dataInicio.ToDate === 'string') {
        const [dia, mes, ano] = dataInicio.ToDate.split('/');
        dataStr = `${ano}-${mes}-${dia}`;
      } else if (dataInicio.SetData && dataInicio.SetData.length === 8) {
        const ano = dataInicio.SetData.substring(0, 4);
        const mes = dataInicio.SetData.substring(4, 6);
        const dia = dataInicio.SetData.substring(6, 8);
        dataStr = `${ano}-${mes}-${dia}`;
      } else if (typeof dataInicio === 'string' && dataInicio.length >= 10) {
        dataStr = dataInicio.substring(0, 10);
      } else {
        return false;
      }

      const partes = dataStr.split('-');
      const data = new Date(Number(partes[0]), Number(partes[1]) - 1, Number(partes[2]));
      data.setHours(0, 0, 0, 0);

      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);

      return data < hoje;
    } catch (e) {
      console.error('Erro ao verificar data:', e);
      return false;
    }
  }

  corrigirDiasGozo(event: Event): void {
    const input = event.target as HTMLInputElement;
    const maxDias = this.programacaoSelecionada?.DiasSaldo || 0;
    let valor = parseInt(input.value, 10) || 0;

    if (valor > maxDias && maxDias > 0) {
      valor = maxDias;
      input.value = valor.toString();
      this.diasGozoSaldo = valor;
    }

    if (valor < 0) {
      valor = 0;
      input.value = valor.toString();
      this.diasGozoSaldo = valor;
    }
    this.diasGozoValido = true;
    this.dataInicioGozoValido = true;
  }

  numeroDoeSaldoValido: boolean = true;
  dtDoeSaldoValido: boolean = true;
  idClassificacaoAtoSaldoValido: boolean = true;
  numeroAtoSaldoValido: boolean = true;
  dtAtoSaldoValido: boolean = true;

  isDataMaiorQueAtual(dataString: string): boolean {
    if (!dataString) return false;
    const data = new Date(dataString);
    const hoje = new Date();
    return data > hoje;
  }

  salvarSaldoFerias(): void {
    this.formProgramacaoFerias.markAllAsTouched();

    this.diasGozoValido = this.diasGozoSaldo !== null && this.diasGozoSaldo > 0;
    this.numeroDoeSaldoValido = !!this.numeroDoeSaldo;
    this.dtDoeSaldoValido = !!this.dtDoeSaldo;
    this.idClassificacaoAtoSaldoValido = !!this.idClassificacaoAtoSaldo;
    this.numeroAtoSaldoValido = !!this.numeroAtoSaldo;
    this.dtAtoSaldoValido = !!this.dtAtoSaldo;

    if (
      !this.diasGozoValido ||
      !this.numeroDoeSaldoValido ||
      !this.dtDoeSaldoValido ||
      !this.idClassificacaoAtoSaldoValido ||
      !this.numeroAtoSaldoValido ||
      !this.dtAtoSaldoValido
    ) {
      Swal('Atenção', 'Preencha todos os campos obrigatórios', 'warning');
      return;
    }

    const dataInicio = this.parseDate(this.dataInicioGozo);
    const dataFim = this.calcularDataFinalCorreta(dataInicio, Number(this.diasGozoSaldo));

    const formatarDataAPI = (date: Date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}${month}${day}`;
    };

    const formatarDataParaEnvio = (dataString: string): string => {
      if (!dataString) return '';
      return dataString.split('-').join('');
    };

    const saldoFeriasRequest = {
      Sigla: 'FAPP',
      NumeroOrdem: Number(this.colaborador.NumeroOrdem),
      PeriodoAquisitivo: {
        DataInicio: {
          SetData: this.formatarDataParaEnvio2(
            this.programacaoSelecionada.PeriodoAquisitivo?.DataInicio?.ToDate
          ),
          ToDate: this.formatarDataBarra(
            this.formatarDataParaEnvio2(
              this.programacaoSelecionada.PeriodoAquisitivo?.DataInicio?.ToDate
            )
          ),
          IsDate: true,
          Empty: false,
        },
        DataFim: {
          SetData: this.formatarDataParaEnvio2(
            this.programacaoSelecionada.PeriodoAquisitivo?.DataFim?.ToDate
          ),
          ToDate: this.formatarDataBarra(
            this.formatarDataParaEnvio2(
              this.programacaoSelecionada.PeriodoAquisitivo?.DataFim?.ToDate
            )
          ),
          IsDate: true,
          Empty: false,
        },
      },
      Competencia: this.programacaoSelecionada.Competencia,
      Dias: Number(this.diasGozoSaldo),
      DataInicio: {
        SetData: formatarDataAPI(dataInicio),
        ToDate: this.formatarDataBarra(formatarDataAPI(dataInicio)),
        IsDate: true,
        Empty: false,
      },
      DataFim: {
        SetData: formatarDataAPI(dataFim),
        ToDate: this.formatarDataBarra(formatarDataAPI(dataFim)),
        IsDate: true,
        Empty: false,
      },
      NumeroProcesso: '',
      NumeroDOE: this.numeroDoeSaldo || '',
      IdClassificacaoAto: this.idClassificacaoAtoSaldo || '',
      NumeroAto: this.numeroAtoSaldo || '',
      AnoAto: this.anoAtoSaldo || '',
      DataAto: this.dtAtoSaldo ? formatarDataParaEnvio(this.dtAtoSaldo) : '',
      AnoDOE: this.anoDoeSaldo || '',
      DataDOE: this.dtDoeSaldo ? formatarDataParaEnvio(this.dtDoeSaldo) : '',
    };

    this.spinner.show();
    this.programacaoFeriasService.salvarSaldoFerias(saldoFeriasRequest).subscribe({
      next: () => {
        this.spinner.hide();
        Swal('Sucesso', 'Gozo de férias salvo com sucesso!', 'success');
        this.listarProgramacaoFerias();
        this.buscarHistoricoGozos();
        this.limparCamposGozoSaldo();
      },
      error: (err) => {
        this.spinner.hide();
        console.error('Erro ao salvar gozo de férias:', err);
        Swal('Erro', err.error?.Mensagem || 'Erro ao salvar gozo de férias.', 'error');
      },
    });
  }

  private parseDate(dateString: string): Date {
    const parts = dateString.split('-');
    return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
  }

  private calcularDataFinalCorreta(dataInicio: Date, dias: number): Date {
    const dataFim = new Date(dataInicio);
    dataFim.setDate(dataInicio.getDate() + dias - 1);
    return dataFim;
  }

  limparCamposGozoSaldo(): void {
    this.diasGozoSaldo = null;
    this.dataInicioGozo = null;
    this.numeroDoeSaldo = null;
    this.dtDoeSaldo = null;
    this.idClassificacaoAtoSaldo = null;
    this.numeroAtoSaldo = null;
    this.dtAtoSaldo = null;
    this.anoDoeSaldo = null;
    this.anoAtoSaldo = null;
  }

  removerGozoFerias(gozo: any): void {
    const numeroOrdem = this.colaborador?.NumeroOrdem?.toString();
    const priAqFerias = this.programacaoSelecionada?.PeriodoAquisitivo?.DataInicio?.SetData;
    const segAqFerias = this.programacaoSelecionada?.PeriodoAquisitivo?.DataFim?.SetData;
    const dataInicioGozo = gozo?.DataInicio?.SetData || gozo?.dataInicio?.SetData;

    if (!numeroOrdem || !priAqFerias || !segAqFerias || !dataInicioGozo) {
      Swal('Erro', 'Dados incompletos para remover o gozo.', 'error');
      return;
    }

    Swal({
      title: 'Deseja realmente remover o gozo de férias?',
      text: 'Essa ação não pode ser desfeita.',
      icon: 'warning',
      buttons: ['Cancelar', 'Confirmar'],
      dangerMode: true,
    }).then((confirmed) => {
      if (confirmed) {
        this.spinner.show();

        this.programacaoFeriasService
          .removerGozoFerias(numeroOrdem, priAqFerias, segAqFerias, dataInicioGozo)
          .subscribe({
            next: () => {
              this.spinner.hide();
              Swal('Sucesso', 'Período de gozo removido com sucesso.', 'success');
              this.buscarHistoricoGozos();
              this.listarProgramacaoFerias();
            },
            error: (error) => {
              this.spinner.hide();
              console.error('Erro ao remover gozo:', error);
              Swal('Erro', error.error?.Mensagem || 'Erro ao remover o gozo.', 'error');
            },
          });
      }
    });
  }

  formatarDataParaEnvio3(data: any): string {
    if (!data) return '';

    if (typeof data === 'string') {
      if (data.includes('-')) {
        return data;
      } else if (data.includes('/')) {
        const [dia, mes, ano] = data.split('/');
        return `${ano}-${mes}-${dia}`;
      } else if (data.length === 8) {
        return `${data.substring(0, 4)}-${data.substring(4, 6)}-${data.substring(6, 8)}`;
      }
    }

    if (typeof data === 'object' && data.SetData) {
      if (data.SetData.length === 8) {
        return `${data.SetData.substring(0, 4)}-${data.SetData.substring(
          4,
          6
        )}-${data.SetData.substring(6, 8)}`;
      }
    }
    console.error('Erro: Tipo de data inválido', data);
    return '';
  }

  downloadPDF() {
    this.spinner.show();
    const empfil = this.programacaoFeriasService.filial;
    const matricula = this.matricula;

    this.programacaoFeriasService.downloadPDF(empfil, matricula).subscribe(
      (data: any) => {
        console.log(data);
        this.spinner.hide();

        const pdf = `data:application/pdf;base64,${data.Base64}`;
        const fileName = `${data.Nome}.pdf`;

        const downloadLink = document.createElement('a');
        downloadLink.href = pdf;
        downloadLink.download = fileName;
        downloadLink.click();
      },
      (err) => {
        console.error(err);
        this.spinner.hide();
      }
    );
  }

  deletarProgramacaoFerias(programacao: any) {
    Swal({
      title: 'Deseja realmente excluir esta Programação',
      text: 'Essa ação não pode ser desfeita.',
      icon: 'warning',
      buttons: ['Cancelar', 'Confirmar'],
    }).then((result) => {
      if (result) {
        this.spinner.show();

        const matricula = this.matricula;
        const empfil = this.programacaoFeriasService.filial;
        const tpProc = programacao.TipoProcessamento;

        const dataInicioPeriodo = this.formatarDataParaEnvio2(
          programacao.PeriodoAquisitivo.DataInicio.ToDate
        );
        const dataFimPeriodo = this.formatarDataParaEnvio2(
          programacao.PeriodoAquisitivo.DataFim.ToDate
        );

        this.programacaoFeriasService
          .deletarProgramacaoFerias(empfil, matricula, tpProc, dataInicioPeriodo, dataFimPeriodo)
          .subscribe({
            next: () => {
              this.spinner.hide();
              Swal('Sucesso', 'Programação de férias deletada com sucesso.', 'success');
              this.programacoesFerias = this.programacoesFerias.filter((p) => p !== programacao);
              this.listarProgramacaoFerias();
              this.buscarPeriodoAquisitivo();
            },
            error: (erro) => {
              this.spinner.hide();
              Swal(
                'Erro',
                erro.error?.Mensagem || 'Não foi possível deletar a programação de férias.',
                'error'
              );
            },
          });
      }
    });
  }

  formatarDataParaEnvio2(dataString: string): string {
    if (!dataString) return '';

    const dataLimpa = dataString.replace(/[^\d/]/g, '');

    if (!/^\d{2}\/\d{2}\/\d{4}$/.test(dataLimpa)) return '';

    const [dia, mes, ano] = dataLimpa.split('/');

    return `${ano}${mes}${dia}`;
  }

  formatarDataParaEnvio(dataString: string): string {
    if (!dataString) return '';

    const [ano, mes, dia] = dataString.split('-');

    const dataFormatada = `${ano}${mes}${dia}`;

    return dataFormatada;
  }

  buscarDataRetorno(campo: string) {
    this.spinner.show();

    this.programacaoFeriasService.buscarParametrosIniciais().subscribe({
      next: (parametros: any) => {
        const empFil = this.programacaoFeriasService.filial;
        const matricula = this.matricula;
        const data = this.formProgramacaoFerias.get(campo).value;

        if (!data) {
          Swal('Erro', `Selecione uma data para ${campo}.`, 'error');
          this.spinner.hide();
          return;
        }

        const dataFormatada = this.formatarDataParaEnvio(data);

        this.programacaoFeriasService
          .buscarDataRetorno(empFil, matricula, dataFormatada)
          .subscribe({
            next: (resposta: any) => {
              if (resposta && resposta.proximoDiaUtil) {
                this.formProgramacaoFerias.get(campo).setValue(resposta.proximoDiaUtil);
              } else {
                Swal(
                  'Aviso',
                  `Não foi possível determinar o próximo dia útil para ${campo}.`,
                  'warning'
                );
              }
            },
            error: () => {
              Swal('Erro', `Erro ao buscar o próximo dia útil para ${campo}.`, 'error');
            },
            complete: () => {
              this.spinner.hide();
            },
          });
      },
      error: (erro) => {
        this.spinner.hide();
        Swal(
          'Erro',
          erro.error?.Mensagem || 'Não foi possível buscar os parâmetros iniciais.',
          'error'
        );
      },
    });
  }

  buscarPeriodoAquisitivo() {
    const empFil = this.programacaoFeriasService.filial;
    const matricula = this.matricula;

    this.programacaoFeriasService.buscarParametrosIniciais().subscribe({
      next: (parametros: any) => {
        const tipoEmpresa = parametros.TipoEmpresa;

        this.programacaoFeriasService
          .buscarPeriodoAquisitivo(empFil, matricula, tipoEmpresa)
          .subscribe({
            next: (response: any) => {
              if (response?.DataInicio?.ToDate && response?.DataFim?.ToDate) {
                const dataInicioFormatada = this.formatarDataParaInput(response.DataInicio.ToDate);
                const dataFimFormatada = this.formatarDataParaInput(response.DataFim.ToDate);

                this.formProgramacaoFerias.get('dataInicioPeriodo')?.setValue(dataInicioFormatada);
                this.formProgramacaoFerias.get('dataFimPeriodo')?.setValue(dataFimFormatada);
              } else {
                Swal('Erro', 'Não foi possível carregar o período aquisitivo.', 'error');
              }
            },
            error: (error) => {
              console.error('Erro ao buscar período aquisitivo:', error);
              Swal('Erro', 'Erro ao buscar período aquisitivo.', 'error');
            },
          });
      },
      error: (error) => {
        console.error('Erro ao buscar parâmetros iniciais:', error);
        Swal('Erro', 'Não foi possível buscar os parâmetros iniciais.', 'error');
      },
    });
  }

  desabilitarParte(parte: number, desabilitar: boolean): void {
    const controles = [
      `situacao${parte}`,
      `dtInicial${parte}`,
      `competencia${parte}`,
      `diasSeremPagos${parte}`,
      `diasGozo${parte}`,
    ];

    const controlesSempreDesabilitados = [`dtFinal${parte}`, `dtRetorno${parte}`];

    controles.forEach((controle) => {
      const campo = this.formProgramacaoFerias.get(controle);
      if (campo) {
        if (desabilitar) {
          campo.setValue('', { emitEvent: false });
          campo.disable({ emitEvent: false });
        } else {
          campo.enable({ emitEvent: false });
        }
      }
    });

    controlesSempreDesabilitados.forEach((controle) => {
      const campo = this.formProgramacaoFerias.get(controle);
      if (campo) {
        campo.disable({ emitEvent: false });
      }
    });
  }

  validarDiasPagos() {
    if (!this.formProgramacaoFerias.get('tipoFerias')?.value) {
      return;
    }

    const diasDescontados = Number(this.formProgramacaoFerias.get('diasDescontados')?.value) || 0;
    let dias1 = Number(this.formProgramacaoFerias.get('diasSeremPagos1')?.value) || 0;
    let dias2 = Number(this.formProgramacaoFerias.get('diasSeremPagos2')?.value) || 0;
    let dias3 = Number(this.formProgramacaoFerias.get('diasSeremPagos3')?.value) || 0;

    const tipoFerias = Number(this.formProgramacaoFerias.get('tipoFerias')?.value);
    const opcaoSelecionada = this.tiposFeriasCache.find((opcao) => opcao.Codigo === tipoFerias);
    const limiteTotal = opcaoSelecionada
      ? Number(opcaoSelecionada.DiasFerias) - diasDescontados
      : 0;
    const totalDiasPagos = dias1 + dias2 + dias3;
    let limiteRestante = Math.max(limiteTotal - totalDiasPagos, 0);

    if (totalDiasPagos > limiteTotal) {
      Swal('Aviso', `O total de dias pagos não pode ultrapassar ${limiteTotal} dias!`, 'warning');

      const excesso = totalDiasPagos - limiteTotal;
      if (dias3 >= excesso) dias3 -= excesso;
      else if (dias2 >= excesso) dias2 -= excesso;
      else if (dias1 >= excesso) dias1 -= excesso;

      this.formProgramacaoFerias.get('diasSeremPagos1')?.setValue(dias1, { emitEvent: false });
      this.formProgramacaoFerias.get('diasSeremPagos2')?.setValue(dias2, { emitEvent: false });
      this.formProgramacaoFerias.get('diasSeremPagos3')?.setValue(dias3, { emitEvent: false });

      limiteRestante = Math.max(limiteTotal - (dias1 + dias2 + dias3), 0);
    }
    if (this.formProgramacaoFerias.get('diasDescontados')?.value !== '') {
      if (limiteRestante === 0) {
        if (dias1 > 0 && dias2 > 0 && dias3 === 0) {
          this.desabilitarParte(3, true);
        } else if (dias1 > 0 && dias3 > 0 && dias2 === 0) {
          this.desabilitarParte(2, true);
        } else if (dias1 > 0 && dias2 === 0 && dias3 === 0) {
          this.desabilitarParte(2, true);
          this.desabilitarParte(3, true);
        }
      } else {
        this.desabilitarParte(1, false);
        this.desabilitarParte(2, false);
        this.desabilitarParte(3, false);
      }
    }

    this.formProgramacaoFerias.get('dtFinal1')?.disable();
    this.formProgramacaoFerias.get('dtRetorno1')?.disable();
    this.formProgramacaoFerias.get('dtFinal2')?.disable();
    this.formProgramacaoFerias.get('dtRetorno2')?.disable();
    this.formProgramacaoFerias.get('dtFinal3')?.disable();
    this.formProgramacaoFerias.get('dtRetorno3')?.disable();

    this.formProgramacaoFerias.get('limiteDias1')?.setValue(limiteRestante);
  }

  validarLimites() {
    const diasDescontados = this.formProgramacaoFerias.get('diasDescontados')?.value || 0;

    let diasPagos1 = this.formProgramacaoFerias.get('diasSeremPagos1')?.value || 0;
    let diasPagos2 = this.formProgramacaoFerias.get('diasSeremPagos2')?.value || 0;
    let diasPagos3 = this.formProgramacaoFerias.get('diasSeremPagos3')?.value || 0;

    let diasGozo1 = this.formProgramacaoFerias.get('diasGozo1')?.value || 0;
    let diasGozo2 = this.formProgramacaoFerias.get('diasGozo2')?.value || 0;
    let diasGozo3 = this.formProgramacaoFerias.get('diasGozo3')?.value || 0;

    let limiteTotalDias = 30 - diasDescontados;
    let totalDiasPagos = diasPagos1 + diasPagos2 + diasPagos3;
    let diasRestantes = limiteTotalDias - totalDiasPagos;

    if (diasPagos1 === limiteTotalDias) {
      diasRestantes = 0;
    }

    if (diasGozo1 > diasPagos1) {
      Swal('Aviso', 'Os dias a gozar não podem ultrapassar os dias de pagamento!', 'warning');
      diasGozo1 = diasPagos1;
    }
    if (diasGozo2 > diasPagos2) {
      Swal('Aviso', 'Os dias a gozar não podem ultrapassar os dias de pagamento!', 'warning');
      diasGozo2 = diasPagos2;
    }
    if (diasGozo3 > diasPagos3) {
      Swal('Aviso', 'Os dias a gozar não podem ultrapassar os dias de pagamento!', 'warning');
      diasGozo3 = diasPagos3;
    }

    this.formProgramacaoFerias.get('diasGozo1')?.setValue(diasGozo1, { emitEvent: false });
    this.formProgramacaoFerias.get('diasGozo2')?.setValue(diasGozo2, { emitEvent: false });
    this.formProgramacaoFerias.get('diasGozo3')?.setValue(diasGozo3, { emitEvent: false });
  }

  verificarDataInicio(campo: string) {
    this.spinner.show();

    this.programacaoFeriasService.buscarParametrosIniciais().subscribe({
      next: (parametros: any) => {
        const empFil = this.programacaoFeriasService.filial;
        const matricula = this.matricula;
        const tipoEmpresa = parametros.TipoEmpresa;
        const data = this.formProgramacaoFerias.get(campo).value;

        if (!data) {
          Swal('Erro', `Selecione uma data para ${campo}.`, 'error');
          this.spinner.hide();
          return;
        }

        const dataFormatada = this.formatarDataParaEnvio(data);

        this.programacaoFeriasService
          .verificarDataInicio(empFil, matricula, tipoEmpresa, dataFormatada)
          .subscribe({
            next: (resposta: any) => {
              if (resposta.diaUtil) {
              }
            },
            error: () => {
              Swal('Aviso', `A data selecionada no campo ${campo} não é um dia útil.`, 'warning');
              this.formProgramacaoFerias.get(campo).setValue(null);
              this.spinner.hide();
            },
            complete: () => {
              this.spinner.hide();
            },
          });
      },
      error: () => {
        Swal('Erro', 'Não foi possível buscar os parâmetros iniciais.', 'error');
        this.spinner.hide();
      },
    });
  }

  calcularDataFinal(parte: number) {
    const dtInicial = this.formProgramacaoFerias.get(`dtInicial${parte}`)?.value;
    const diasGozo = this.formProgramacaoFerias.get(`diasGozo${parte}`)?.value;

    if (dtInicial) {
      let dataFinal: string;

      if (!diasGozo || parseInt(diasGozo, 10) === 0) {
        dataFinal = dtInicial;
      } else {
        let dataInicialObj = new Date(dtInicial);
        let dataFinalObj = new Date(dataInicialObj);
        dataFinalObj.setDate(dataInicialObj.getDate() + parseInt(diasGozo, 10));
        dataFinal = dataFinalObj.toISOString().split('T')[0];
      }

      this.formProgramacaoFerias.get(`dtFinal${parte}`)?.setValue(dataFinal, { emitEvent: false });

      this.calcularDiaRetorno(parte);
    }
  }

  calcularDiaRetorno(parte: number) {
    const dtFinal = this.formProgramacaoFerias.get(`dtFinal${parte}`)?.value;
    const diasGozo = this.formProgramacaoFerias.get(`diasGozo${parte}`)?.value;

    if (diasGozo === 0 || diasGozo === '0') {
      this.formProgramacaoFerias.get(`dtRetorno${parte}`)?.setValue(dtFinal, { emitEvent: false });
      return;
    }

    if (dtFinal) {
      const empFil = this.programacaoFeriasService.filial;
      const matricula = this.matricula;
      const dtFinalFormatada = this.formatarDataParaEnvio(dtFinal);

      this.programacaoFeriasService
        .calcularDiaRetorno(empFil, matricula, dtFinalFormatada)
        .subscribe(
          (response: any) => {
            if (response?.ToDate) {
              const dtRetornoFormatada = this.formatarDataParaInput(response.ToDate);
              this.formProgramacaoFerias
                .get(`dtRetorno${parte}`)
                ?.setValue(dtRetornoFormatada, { emitEvent: false });
            } else {
              Swal('Erro', 'Formato de data inválido da API.', 'error');
            }
          },
          (error) => {
            console.error('Erro ao calcular retorno:', error);
            Swal('Erro', 'Falha ao calcular o dia de retorno.', 'error');
          }
        );
    }
  }

  formatarDataParaInput(data: string): string {
    const partes = data.split('/');
    if (partes.length === 3) {
      return `${partes[2]}-${partes[1]}-${partes[0]}`;
    }
    return '';
  }
}

export interface Programacao {
  Obs: 'S' | 'N';
  Documento: 'S' | 'N';
  PeriodoAquisitivo: {
    DataInicio: {
      ToDate: string;
      SetData?: string;
      Empty?: boolean;
      IsDate?: boolean;
    };
    DataFim: {
      ToDate: string;
      SetData?: string;
      Empty?: boolean;
      IsDate?: boolean;
    };
  };
  TipoProcessamento: string;
  Situacao: {
    Codigo: number;
    Descricao: string;
  };
  DiasSeremPagos: number;
  DiasGozo: number;
  QuantidadeAgrupada?: number;

  Sigla?: string;
  EmpresaFilial?: string;
  Matricula?: number;
  DiasGozoRessalva?: number;
  TipoFerias?: string;
  NumeroProcesso?: string;
  NumeroDOE?: string;
  IdClassificacaoAto?: string;
  NumeroAto?: string;
  AnoAto?: string;
  DataAto?: {
    SetData?: string;
    ToDate?: string;
    Empty?: boolean;
    IsDate?: boolean;
  };
  AnoDOE?: string;
  DataDOE?: {
    SetData?: string;
    ToDate?: string;
    Empty?: boolean;
    IsDate?: boolean;
  };
  CompAtualizacao?: string;
  DiasSaldo?: number;
  PartesFerias?: Array<{
    Competencia?: string;
    Situacao?: number;
    DiasGozo?: number;
    DataInicio?: {
      SetData?: string;
      ToDate?: string;
      Empty?: boolean;
      IsDate?: boolean;
    };
    DataFim?: {
      SetData?: string;
      ToDate?: string;
      Empty?: boolean;
      IsDate?: boolean;
    };
    DataRetorno?: {
      SetData?: string;
      ToDate?: string;
      Empty?: boolean;
      IsDate?: boolean;
    };
    Condespensa?: number;
  }>;
  Nome?: string;
  Vinculo?: string;
  CodigoAfastamento?: string;
  DescricaoAfastamento?: string;
  F11?: number;
  DataAfastamento?:
    | {
        SetData?: string;
        ToDate?: string;
      }
    | string;
  DiasDescontados?: number;
  DiasFaltas?: number;
}
